import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/*
 * All things storage.  Kind of like redux off steroids
 */
var SessionStorage =
/*#__PURE__*/
function () {
  function SessionStorage(remote) {
    _classCallCheck(this, SessionStorage);

    this.data = {};
    this.listeners = {};
    this.settingsListeners = {};
    this.activeCalls = {};
    this.remote = remote;
    this.get = this.get.bind(this);
    this.put = this.put.bind(this);
    this.getOrFetch = this.getOrFetch.bind(this);
    this.refresh = this.refresh.bind(this);
    this.logout = this.logout.bind(this);
    this.clear = this.clear.bind(this);
  }

  _createClass(SessionStorage, [{
    key: "get",
    value: function get(key) {
      return this.data[key] || null;
    }
  }, {
    key: "put",
    value: function put(key, value) {
      this.data[key] = value;
      this.wasMutated(key, value);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.data = {};
    }
  }, {
    key: "clear",
    value: function clear(regex) {
      var _arr = Object.entries(this.data);

      for (var _i = 0; _i < _arr.length; _i++) {
        var _ref3 = _arr[_i];

        var _ref2 = _slicedToArray(_ref3, 2);

        var key = _ref2[0];
        var value = _ref2[1];

        if (key.match(regex)) {
          delete this.data[key];
        }
      }
    }
  }, {
    key: "logout",
    value: function logout() {
      this.clear();
      this.remote.logout();
    }
    /*
     * Returns a promise of the given data
     */

  }, {
    key: "getOrFetch",
    value: function getOrFetch(apiCall, refresh) {
      var _this = this;

      //Is it already cached?
      var result = this.get(apiCall);

      if (!refresh && result !== null) {
        return Promise.resolve(result);
      } else {
        //Is there already a call in play?
        if (this.activeCalls.hasOwnProperty(apiCall)) {
          return this.activeCalls[apiCall];
        } else {
          var promise = this.remote.get(apiCall).then(function (x) {
            _this.put(apiCall, x);

            delete _this.activeCalls[apiCall];
            return x;
          }).catch(function (e) {
            delete _this.activeCalls[apiCall];
          });
          this.activeCalls[apiCall] = promise;
          return promise;
        }
      }
    }
  }, {
    key: "refresh",
    value: function refresh(apiCall) {
      var _this2 = this;

      return this.getOrFetch(apiCall, true).then(function (x) {
        _this2.wasMutated(apiCall, x);

        return x;
      });
    }
  }, {
    key: "refreshRequired",
    value: function refreshRequired(apiCall) {
      var listenerList = this.listeners[apiCall];

      if (!listenerList) {
        //Just clear it
        delete this.data[apiCall];
        return;
      }

      return this.refresh(apiCall);
    }
  }, {
    key: "watch",
    value: function watch(key, listener) {
      var listenerList = this.listeners[key];

      if (!listenerList) {
        listenerList = [];
        this.listeners[key] = listenerList;
      }

      listenerList.push(listener);
    }
  }, {
    key: "unwatch",
    value: function unwatch(key, listener) {
      var listenerList = this.listeners[key];

      if (!listenerList) {
        return;
      }

      this.listeners[key] = listenerList.filter(function (x) {
        return x !== listener;
      });
    }
  }, {
    key: "wasMutated",
    value: function wasMutated(key, value) {
      var listenerList = this.listeners[key];
      if (!listenerList) return;

      for (var i = listenerList.length - 1; i >= 0; i--) {
        listenerList[i](value);
      }
    } //Shortcut method for getting user settings

  }, {
    key: "getSetting",
    value: function getSetting(key) {
      //Always download latest settings (?????TODO store locally while waiting for download?????)
      return this.getOrFetch("/users/current-user/settings").then(function (settings) {
        return settings[key];
      });
    }
  }, {
    key: "addToSettingsList",
    value: function addToSettingsList(key, value, size) {
      var _this3 = this;

      //Save it locally
      this.getOrFetch("/users/current-user/settings").then(function (settings) {
        var list = settings[key];

        if (!list) {
          list = [];
          settings[key] = list;
        } //Remove it if it's already in the list, so we don't get doubleups


        var index = list.indexOf(value);

        if (index > -1) {
          list.splice(index, 1);
        } //Add it


        list.unshift(value);

        if (size && list.length > size) {
          list.splice(size, list.length - size);
        } //Save it globally


        var data = {};
        data[key] = list;

        _this3.remote.put("/users/current-user/settings", data); //Trigger necessary events.


        _this3.settingWasMutated(key, list);
      });
    }
  }, {
    key: "removeFromSettingsList",
    value: function removeFromSettingsList(key, value) {
      var _this4 = this;

      //Save it locally
      this.getOrFetch("/users/current-user/settings").then(function (settings) {
        var list = settings[key];

        if (!list) {
          return;
        } //Remove it 


        var index = list.indexOf(value);

        if (index > -1) {
          list.splice(index, 1);
        } //Save it globally


        var data = {};
        data[key] = list;

        _this4.remote.put("/users/current-user/settings", data); //Trigger necessary events.


        _this4.settingWasMutated(key, list);
      });
    }
  }, {
    key: "putSetting",
    value: function putSetting(key, value) {
      //Save it locally
      this.getOrFetch("/users/current-user/settings").then(function (settings) {
        return settings[key] = value;
      }); //Save it globally

      var data = {};
      data[key] = value;
      this.remote.put("/users/current-user/settings", data); //Trigger necessary events.

      this.settingWasMutated(key, value);
    }
  }, {
    key: "putSettings",
    value: function putSettings(data) {
      var _this5 = this;

      this.getOrFetch("/users/current-user/settings").then(function (settings) {
        return Object.assign(settings, data);
      });
      this.remote.put("/users/current-user/settings", data); //Trigger necessary events.

      data.keys().forEach(function (key) {
        _this5.settingWasMutated(key, data[key]);
      });
    }
  }, {
    key: "settingWasMutated",
    value: function settingWasMutated(key, value) {
      var listenerList = this.settingsListeners[key];

      if (!listenerList) {
        return;
      }

      for (var i = listenerList.length - 1; i >= 0; i--) {
        listenerList[i](value);
      }
    }
  }, {
    key: "watchSetting",
    value: function watchSetting(key, listener) {
      var listenerList = this.settingsListeners[key];

      if (!listenerList) {
        listenerList = [];
        this.settingsListeners[key] = listenerList;
      }

      listenerList.push(listener);
    }
  }, {
    key: "unwatchSetting",
    value: function unwatchSetting(key, listener) {
      var listenerList = this.settingsListeners[key];

      if (!listenerList) {
        return;
      }

      this.settingsListeners[key] = listenerList.filter(function (x) {
        return x !== listener;
      });
    } //NON session stuff

  }, {
    key: "getPermanentlyStored",
    value: function getPermanentlyStored(key) {
      return localStorage.getItem(key);
    }
  }, {
    key: "setPermanentlyStored",
    value: function setPermanentlyStored(key, value) {
      localStorage.setItem(key, value);
    }
  }]);

  return SessionStorage;
}();

export default SessionStorage;